import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/Rx';
import {environment} from '../../environments/environment';

@Injectable()
export class AuthenticateService {
    public token: string;
    public currentUser: any;
    private httpBearerOptions = {};
    private httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };

    constructor(private http: HttpClient) {
        this.token = localStorage.getItem('token');
        this.httpBearerOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token
            })
        };
    }

    login(data: any): Observable<any> {
        return this.http.post(environment.apiBaseUrl + 'super-admin-login',
            JSON.stringify(data), this.httpOptions)
            .map((response: Response) => {
                if (response) {
                    this.currentUser = response;
                    this.token = this.currentUser.token;
                    localStorage.setItem('token', this.token);
                    localStorage.setItem('user', JSON.stringify(this.currentUser.adminUser));
                    this.httpBearerOptions = {
                        headers: new HttpHeaders({
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        })
                    };
                    return response;
                }
            });
    }

    loginWithTfa(data: any): Observable<any> {
        return this.http.post(environment.apiBaseUrl + 'super-admin-tfa-login',
            JSON.stringify(data), this.httpOptions)
            .map((response: any) => {
                if (response && response.tfa) {
                    return response;
                } else if (response) {
                    this.currentUser = response;
                    this.token = this.currentUser.token;
                    localStorage.setItem('token', this.token);
                    localStorage.setItem('user', JSON.stringify(this.currentUser.adminUser));
                    this.httpBearerOptions = {
                        headers: new HttpHeaders({
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        })
                    };
                    return response;
                }
            });
    }

    createTfa(data: any): Observable<any> {
        return this.http.post(environment.apiBaseUrl + 'super-admin-tfa-create',
            JSON.stringify(data), this.httpOptions)
            .map((response: any) => {
                if (response && response.tfa) {
                    return response;
                }
            });
    }

    verifyAuth(data: any, authCode): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'x-tfa-token': authCode.toString()
            })
        };
        return this.http.post(environment.apiBaseUrl + 'super-admin-tfa-verify',
            JSON.stringify(data), httpOptions)
            .map((response: any) => {
                console.log(response);
                if (response.status) {
                    this.currentUser = response;
                    this.token = this.currentUser.token;
                    localStorage.setItem('token', this.token);
                    localStorage.setItem('user', JSON.stringify(this.currentUser.adminUser));
                    this.httpBearerOptions = {
                        headers: new HttpHeaders({
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        })
                    };
                }
                return response;

            });
    }

    disableTfaAuth(data: any, authCode): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'x-tfa-token': authCode.toString()
            })
        };
        return this.http.post(environment.apiBaseUrl + 'super-admin-tfa-disable',
            JSON.stringify(data), httpOptions)
            .map((response: any) => {
                console.log(response);
                if (response.status) {
                    this.currentUser = response;
                    this.token = this.currentUser.token;
                    localStorage.setItem('token', this.token);
                    localStorage.setItem('user', JSON.stringify(this.currentUser.adminUser));
                    this.httpBearerOptions = {
                        headers: new HttpHeaders({
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        })
                    };
                }
                return response;
            });
    }

    logout(): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'super-admin-logout',
            this.httpBearerOptions)
            .map((response: Response) => {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.token = null;
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }
    register(Data: any): Observable<any> {
        return this.http.post(environment.apiBaseUrl + 'super-admin-register',
            JSON.stringify(Data),
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    getUsers(): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'getSuperAdminUsers',
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }
    deleteUser(id: String): Observable<any> {
        return this.http.delete(environment.apiBaseUrl + 'deleteSuperAdminUsers/' + id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }
    updateUser(Data: any, id: String): Observable<any> {
        return this.http.put(environment.apiBaseUrl + 'updateSuperAdminUsers/' + id,
            JSON.stringify(Data),
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/services/authenticate.service.ts